import React from "react";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import ExitToApp from "@mui/icons-material/ExitToApp";

import { withState } from "../../../services/state";

import SlateLogo from "./Logo.png";

// Styled components using MUI v5 `styled` and proper breakpoint syntax
const PageHeaderRoot = styled("div")(({ theme }) => ({
  width: "100%",
  height: 60,
  backgroundColor: "#fff",
  borderBottom: "5px solid #47d45a",
  padding: 10,
  [theme.breakpoints.down("sm")]: {
    height: 50,
    display: "flex",
    alignItems: "center",
  },
}));

const PageHeaderLogo = styled("img")(({ theme }) => ({
  height: 40,
  [theme.breakpoints.down("sm")]: {
    height: 30,
    marginRight: 10,
  },
}));

const PageHeaderTitle = styled("div")({
  color: "#000",
  fontWeight: "bold",
  fontSize: 14,
});

const MenuToggle = styled("div")({
  cursor: "pointer",
  marginRight: 10,
  color: "#000",
});

const PageHeaderContent = styled("div")(({ theme }) => ({
  textAlign: "center",
  height: "100%",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.down("sm")]: {
    display: "flex",
    alignItems: "center",
  },
}));

const LeftSection = styled("div")({
  display: "flex",
  alignItems: "center",
});

const RightSection = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 16,
});

const LogoutButton = styled("div")({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  color: "#555",
  fontSize: 13,
  fontWeight: 500,
  gap: 4,
  padding: "5px 10px",
  borderRadius: 4,
  "&:hover": {
    color: "#000",
    backgroundColor: "#f5f5f5",
  },
});

function PageHeader({ setShowMinimizedSidebar, context, dispatch }) {
  const navigate = useNavigate();

  let logo = SlateLogo;
  if (context.organizationData) {
    logo = context.organizationData.logoSmallImageUrl;
  }

  let appHeader = "Player App";

  if (context.currentClub.isTreasurer) {
    appHeader = "Player App (Admin View)";
  } else if (context.currentClub.isCaptain) {
    appHeader = "Captain Portal";
  }

  const logout = () => {
    dispatch({ type: "clearToken" });
    dispatch({ type: "clearSessionVariables" });
    dispatch({ type: "clearProfile" });
    navigate("/");
  };

  return (
    <PageHeaderRoot>
      {window.innerWidth < 960 && (
        <MenuToggle onClick={() => setShowMinimizedSidebar()}>
          <MenuIcon />
        </MenuToggle>
      )}
      <PageHeaderContent>
        <LeftSection>
          <PageHeaderLogo alt="Slate logo" src={logo} />
        </LeftSection>
        <RightSection>
          {context.loggedIn && (
            <>
              <PageHeaderTitle>{appHeader}</PageHeaderTitle>
              <LogoutButton onClick={logout}>
                <ExitToApp fontSize="small" />
                Logout
              </LogoutButton>
            </>
          )}
        </RightSection>
      </PageHeaderContent>
    </PageHeaderRoot>
  );
}

export default withState(PageHeader);
